export default "__VITE_ASSET__DiwAWkAn__"